<template>
  <f7-page-content>    
    <f7-messages ref="messages" v-if="messagesData.length">
      <f7-message
        v-for="(message, index) in messagesData"
        :key="index"
        :type="message.type"
        :image="message.image"
        :name="message.name"
        :avatar="message.avatar"
        :first="isFirstMessage(message, index)"
        :last="isLastMessage(message, index)"
        :tail="isTailMessage(message, index)"
      >
      <span slot="text" v-if="message.text" v-html="message.text"></span>
      </f7-message>
      <f7-message v-if="typingMessage"
        type="received"
        :typing="true"
        :first="true"
        :last="true"
        :tail="true"
        :header="`${typingMessage.name} is typing`"
        :avatar="typingMessage.avatar"
      ></f7-message>
    </f7-messages>
  </f7-page-content>
</template>
<script>
 import { mapGetters } from 'vuex'
 import RobotImageUrl from '@/css/images/robot-icon.svg'
  export default {
    data() {
      return {
        typingMessage: null,
        messagesData: [],
        people: [
          {
            name: 'OnAir',
            avatar: RobotImageUrl
          }
        ],
        answers: [],
        responseInProgress: false,
        answerno: -1
      };
    },
    computed: {
      ...mapGetters([
        'resource'
      ]),
      placeholder() {
        const self = this;
        return 'Message';
      },
    },
    created () {
      this.handleRobot()
      this.answers.push(this.resource.RobotMessage1)
      this.answers.push(this.resource.RobotMessage2)
      this.answers.push(this.resource.RobotMessage3)
    },
    methods: {
      isFirstMessage(message, index) {
        const self = this;
        const previousMessage = self.messagesData[index - 1];
        if (message.isTitle) return false;
        if (!previousMessage || previousMessage.type !== message.type || previousMessage.name !== message.name) return true;
        return false;
      },
      isLastMessage(message, index) {
        const self = this;
        const nextMessage = self.messagesData[index + 1];
        if (message.isTitle) return false;
        if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
        return false;
      },
      isTailMessage (message, index) {
        const self = this;
        const nextMessage = self.messagesData[index + 1];
        if (message.isTitle) return false;
        if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
        return false;
      },
      handleRobot () {
        let self = this
        if(self.answerno == 2) {
          self.responseInProgress = false;
          return;
        }
        self.answerno++
        setTimeout(() => {
          const answer = self.answers[self.answerno];
          const person = self.people[0];
          self.typingMessage = {
            name: person.name,
            avatar: person.avatar,
          };
          setTimeout(() => {
            self.messagesData.push({
              text: answer,
              type: 'received',
              name: person.name,
              avatar: person.avatar,
            });
            self.typingMessage = null;
            self.responseInProgress = false;
          }, 1000);
        }, 1000);
      },
      sendRobotMessage (text) {
        const self = this;
        const messagesToSend = [];
        if (text.trim().length) {
          messagesToSend.push({
            text,
          });
        }
        if (messagesToSend.length === 0) {
          return;
        }
        // Send message
        self.messagesData.push(...messagesToSend);
        // Mock response
        if (self.responseInProgress) return;
        self.responseInProgress = true;

        console.log('outer answer count', this.answerno)
        this.handleRobot()
      },
    },
  };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/chat/RobotChat.vue